// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__2GpYI","colCheckbox":"styles_colCheckbox__upBVK"};